import { render, staticRenderFns } from "./CommunityDropDown.vue?vue&type=template&id=5e2652d4&scoped=true&"
var script = {}
import style0 from "./CommunityDropDown.vue?vue&type=style&index=0&id=5e2652d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2652d4",
  null
  
)

export default component.exports